import React, { useEffect, useState } from 'react';
import { useVersionCheck } from '../../hooks/useVersionCheck';

// Tvingende oppdatering: banneret teller ned og laster siden på nytt automatisk.
// Operatøren kan oppdatere umiddelbart med knappen, men kan ikke avvise banneret.
// Påbegynte linjer lagres fortløpende server-side, så en reload mister ikke arbeid.
const AUTO_RELOAD_SECONDS = 60;

export const VersionUpdateBanner: React.FC = () => {
  const { newVersionAvailable, refresh } = useVersionCheck();
  const [secondsLeft, setSecondsLeft] = useState(AUTO_RELOAD_SECONDS);

  useEffect(() => {
    if (!newVersionAvailable) return;

    setSecondsLeft(AUTO_RELOAD_SECONDS);
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          refresh();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [newVersionAvailable, refresh]);

  if (!newVersionAvailable) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-blue-600 text-white px-4 py-2 flex items-center justify-center gap-3 shadow-md">
      <span className="text-sm font-medium">
        En ny versjon av applikasjonen er tilgjengelig. Oppdaterer automatisk om {secondsLeft} sek.
      </span>
      <button
        onClick={refresh}
        className="bg-white text-blue-600 text-sm font-semibold px-3 py-1 rounded hover:bg-blue-50 transition-colors"
      >
        Oppdater nå
      </button>
    </div>
  );
};
